var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('depositPopup'),_c('withdrawPopup'),_c('bankSet'),_c('withdrawPwdSetPopup'),_c('loadingPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }